// removed by extract-text-webpack-plugin
module.exports = {"loader":"loader--3vxaA","bar":"bar--2ZFJM","fade":"fade--38kQL"};